//import {TweenMax, Expo} from 'gsap';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger);

gsap.to(".test", {
	scrollTrigger: ".test",
  x: 500
});
